export interface IEventEmitter<EventsMap = {}> {
    on(id: string | symbol, callback: Function, owner: Object, priority?: number, data?: any): void;

    off(id: string | symbol, owner: Object): void;

    emit(id: string | symbol, ...args: any[]): void;

    onEvent(id: any, callback: () => void, context: Object): void;

    emitEvent<K extends keyof EventsMap>(id: K, data: any): void;
}
